<template>
    <div class="modal-backdrop">

    </div>
</template>

<script>
    export default {
        name: 'modal',
        props: {
            clickedPoint: ['clickedPoint']
        },
        data () {
            return {
                dialog: true,
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },
        },
    };
</script>


